module.exports = __webpack_public_path__ + "img/52114110_L.80ae5692.png";